export function newJson(data){
    return JSON.parse(JSON.stringify(data));
}